/* gsw-cart-edit.js — GSW sepet "Edit" / "Preview" bağlantıları (PARA YOLU; iki canlı temadaki assets/gsw-cart-edit.js'ten
 * taşındı, U07 09.10.2026). Layout H5 kancasıyla her sayfada defer yüklenir.
 * Sorun: bazı satırlar (uygulama ya da eski yol) özelliği DÜZ METİN basar; müşteri tasarımını düzenlemek için adresi elle
 * kopyalamak zorunda kalırdı. Çözüm: /apps/<uygulama>?design=… ve /files/previews/… içeren metin düğümlerini tıklanabilir
 * bağlantıya çevirir. Bizim sepet satırları (brand-cart-products / gsw-cart-line) bağlantıyı zaten Liquid'de basar; bu
 * dosya yalnız kalan düz metni yakalar.
 * Taşırken değişen: satır içi renk/stil (sabit hex + gradyan) kalktı → sınıf `brand-cart-edit` (+ `--primary`), stil
 * assets/brand-cart.css'te sözleşme jetonlarıyla; emoji yok. Tarama yalnız sepet bileşenlerinde (cart-items-component)
 * ve onlar yeniden çizildiğinde (MutationObserver, 150 ms gecikme) çalışır; sayfada sepet yoksa iş yapılmaz.
 */
(function () {
  var EDIT_RE = /https?:\/\/[^\s"']+\/apps\/[a-z0-9-]+\?design=[A-Za-z0-9_-]+/i;
  var PREVIEW_RE = /https?:\/\/[^\s"']+\/files\/previews\/[^\s"']+/i;
  var ROOTS = 'cart-items-component';

  function linkify(parent, href, label, primary, external) {
    var a = document.createElement('a');
    a.href = href;
    a.textContent = label;
    a.className = 'brand-cart-edit' + (primary ? ' brand-cart-edit--primary' : '');
    if (external) {
      a.target = '_blank';
      a.rel = 'noopener nofollow';
    }
    parent.textContent = '';
    parent.appendChild(a);
    parent.setAttribute('data-gsw-linked', '1');
  }

  function walk(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var hits = [];
    var n;
    while ((n = w.nextNode())) {
      var t = n.nodeValue || '';
      if (t.length > 400) continue;
      if (EDIT_RE.test(t) || PREVIEW_RE.test(t)) hits.push(n);
    }
    for (var i = 0; i < hits.length; i++) {
      var node = hits[i];
      var parent = node.parentElement;
      if (!parent || parent.getAttribute('data-gsw-linked') === '1') continue;
      if (parent.closest && parent.closest('a, script, style, textarea')) continue;
      var text = node.nodeValue || '';
      var m = text.match(EDIT_RE);
      if (m) {
        linkify(parent, m[0], 'Edit this design', true, false);
        continue;
      }
      var p = text.match(PREVIEW_RE);
      if (p) linkify(parent, p[0], 'Preview', false, true);
    }
  }

  function run() {
    try {
      var roots = document.querySelectorAll(ROOTS);
      for (var i = 0; i < roots.length; i++) walk(roots[i]);
    } catch (e) {
      /* beklenmedik DOM: sessiz geç */
    }
  }

  function boot() {
    // Horizon sepet olayı (assets/events.js 'cart:update'): bileşen morph ile değişmiş olabilir, yeniden tara
    document.addEventListener('cart:update', function () {
      setTimeout(run, 200);
    });
    if (!document.querySelector(ROOTS)) return;
    run();
    var pending = null;
    var mo = new MutationObserver(function () {
      if (pending) clearTimeout(pending);
      pending = setTimeout(run, 150);
    });
    var roots = document.querySelectorAll(ROOTS);
    for (var i = 0; i < roots.length; i++) mo.observe(roots[i], { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
